<p class="bold-text" *ngIf="title">{{ title }}</p>
<div class="phone-wrap">
  <div class="phone" [ngClass]="{ 'phone-invalid': error.invalid && (!error.dirty || error.touched || forceTouched) }">
    <div class="phone__input">
      <div class="phone-container">
        <form action="" class="phone-form" [formGroup]="phoneGroup">
          <ngx-intl-tel-input
            role="textbox"
            aria-label="Phone number"
            appTelPasteFix
            [cssClass]="'phone-custom'"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [onlyCountries]="allowCountries"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="selectedCountry"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="separateDialCode"
            [numberFormat]="PhoneNumberFormat.National"
            [disabled]="isUpdating"
            customPlaceholder="(555)555-5555"
            type="phone"
            formControlName="phone"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          >
          </ngx-intl-tel-input>
        </form>
      </div>
      <div class="required-symbol">*</div>
      <div class="btn-container">
        <button
          aria-label="Verify phone number"
          role="button"
          class="phone__input-button {{ verifyButtonTextStyle }}"
          *ngIf="showVerifyButton && !startSent && !error.invalid"
          [ngStyle]="{ cursor: enableVerifyButton ? 'pointer' : 'default' }"
          [disabled]="!enableVerifyButton"
          (click)="getVerificationCode()"
        >
          {{ verifyButtonText }}
        </button>
        <div class="phone__input-button spinner-wrapper" *ngIf="startSent">
          <app-spinner class="phone-spinner"></app-spinner>
        </div>
      </div>
    </div>
    <div class="phone__verification" *ngIf="needVerification">
      <span class="phone__verification-description">Enter code to verify</span>
      <div>
        <app-sms-code
          aria-label="Verification code"
          (enterCode)="sendVerifyingCode($event)"></app-sms-code>
      </div>
      <span class="phone__verification-error" *ngIf="codeFailed">Invalid code</span>
    </div>
  </div>
</div>

<p class="phone__input-error" *ngIf="error.invalid && (!error.dirty || error.touched || forceTouched)">{{ errorMessage }}</p>
<!-- <div *ngIf="isIos && showAuth && !userVerified" class="instruction"> Sign in with </div>
<app-customer-auth *ngIf="showAuth && !userVerified" [isNeedSharingPhoneNumber]="isNeedSharingPhoneNumber" (isAuthenticated)="receiveAuth($event)"></app-customer-auth> -->
